var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-with-trade-mark"},[_c('logo'),_vm._v(" "),_c('span',{staticClass:"trade-mark"},[_vm._v("TM")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }